import React from 'react';
import createClient from './apolloClient';
import { ApolloProvider } from '@apollo/client';
import { Route, useLocation, Routes } from 'react-router-dom';
import { Frame } from '@shopify/polaris';
import { createGlobalStyle } from 'styled-components';
import queryString from './utils/queryString';
import {
  useAppBridge
} from '@shopify/app-bridge-react';
import Embedded from './components/Embedded';
import ShopPayRedirect from 'components/ShopPay/shop-pay-redirect';


const AppProvider = ({ children }) => {
  const app = useAppBridge();
  window.app = app;

  const client = createClient(app);

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};

const GlobalStyles = createGlobalStyle`
  .Polaris-Modal-Dialog__Modal {
    max-width: 100% !important;
    width: 749px !important;
  }
`;

const SHOP_PAY_REDIRECT_URI = '/shopify/pay/redirect_uri';
const App = () => {
  const location = useLocation();
  const { search } = location;
  const { shop } = queryString.parse(search);

  if (location.pathname === SHOP_PAY_REDIRECT_URI) {
    return <ShopPayRedirect />;
  }

  // Not loading in an iframe AND no shop parameter
  if (window.top === window.self && !shop) {
    return null;
  }

  // Loaded within shopify admin
  return (
      <AppProvider>
        <Frame>
          <GlobalStyles />
          <Routes location={location}>
            <Route path="/*" element={<Embedded />} />
          </Routes>
        </Frame>
      </AppProvider>
  );
};

export default App;
